import { ReducerActionRotaSP } from 'store/modules/types';

import { ConsultarParametroLocalidadesSiglaRequest, Types } from './types';

export function consultarParametroLocalidadesSiglaRequest(
	token: string,
	data: ConsultarParametroLocalidadesSiglaRequest,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA,
		token,
		payload: {
			sigla: data.sigla,
			idOrgao: data.idOrgao,
		},
	};
}
export function consultarParametroLocalidadesSiglaSuccess(
	payload: object,
): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_SUCCESS,
		payload,
	};
}
export function consultarParametroLocalidadesSiglaFailure(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_FAILURE,
		payload: null,
	};
}
export function consultarParametroLocalidadesSiglaClear(): ReducerActionRotaSP {
	return {
		type: Types.CONSULTAR_PARAMETRO_LOCALIDADES_SIGLA_CLEAR,
		payload: null,
	};
}
